import { getSuggestedDisplayPrice } from 'site-modules/shared/utils/core-page/suggested-price';

const PRICE_BAR_BASE_WIDTH = 50;
export function getPriceBarSettings(trims, { maxWidth = 90 } = {}) {
  const variableWidth = maxWidth - PRICE_BAR_BASE_WIDTH;
  const trimESPs = trims.map(getSuggestedDisplayPrice);
  let minPrice = Math.min(...trimESPs);
  let maxPrice = Math.max(...trimESPs);

  // When there is only 1 price
  if (minPrice === maxPrice) {
    minPrice *= 0.5;
    maxPrice *= 1.5;
  }

  return { basePrice: minPrice, percentValue: (maxPrice - minPrice) / variableWidth };
}

export function getPriceBarWidth({ priceBarSettings: { basePrice, percentValue }, suggestedPrice }) {
  return PRICE_BAR_BASE_WIDTH + (suggestedPrice - basePrice) / percentValue;
}
